
import { Vue, Component, Prop } from 'vue-property-decorator'
import AvatarBasic from '~/components/common/AvatarBasic.vue'

@Component({
  name: 'UserInformPanel',
  components: {
    AvatarBasic
  }
})
export default class UserInformPanel extends Vue {
  @Prop({ default: true }) isShort!: boolean
  @Prop({ type: Boolean, default: false }) isGame!: boolean
  @Prop({ type: String, default: '' }) levelInfo!: string
}
